exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1siFqY_wpsPSG3{align-items:center;color:rgba(9,30,66,.71);display:flex;margin-right:8px;padding:0 24px 8px 12px}._1siFqY_wpsPSG3:hover{color:rgba(9,30,66,.77)}._1siFqY_wpsPSG3:active{color:rgba(9,30,66,.89)}._1siFqY_wpsPSG3.JFnIM4cyxCW4i2{margin-bottom:-2px;color:#026aa7;border-bottom:2px solid #5ba4cf}._1siFqY_wpsPSG3:not(.JFnIM4cyxCW4i2){cursor:pointer;text-decoration:none}@media only screen and (max-width:711px){._1siFqY_wpsPSG3{width:50%;justify-content:center;padding-right:12px;margin-right:0}}._3hYkbx9cXEpKMY{border-bottom:2px solid rgba(9,30,66,.25);display:flex;justify-content:flex-start;margin-bottom:20px}._3r2K_p1t78v13f{display:inline-block;font-size:14px;margin-right:2px;color:#7a869a}._1siFqY_wpsPSG3:active ._3r2K_p1t78v13f,._1siFqY_wpsPSG3:hover ._3r2K_p1t78v13f{color:#505f79}._1siFqY_wpsPSG3.JFnIM4cyxCW4i2 ._3r2K_p1t78v13f{color:#0079bf}.n7c7W3-Oh51iK3{color:currentcolor!important}", ""]);

// exports
exports.locals = {
	"headerTab": "_1siFqY_wpsPSG3",
	"selected": "JFnIM4cyxCW4i2",
	"headerTabBar": "_3hYkbx9cXEpKMY",
	"icon": "_3r2K_p1t78v13f",
	"iconSpan": "n7c7W3-Oh51iK3"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"modules":true,"importLoaders":2,"localIdentName":"[hash:base64:14]","sourceMap":false}!./node_modules/postcss-loader/lib?{"config":{"path":"/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-3053/tools/webpack/postcss.config.js"},"sourceMap":true}!./node_modules/less-loader/dist/cjs.js?{"outputStyle":"expanded","sourceMap":false}!./app/scripts/views/home/presentational/header-tab-bar.less
// module id = JQKM
// module chunks = 24